import { html, unsafeCSS, CSSResultGroup } from "lit";
import { customElement, property } from "lit/decorators.js";
import informationBlockStyles from "../../styles/information-block.css?inline";
import { ApidaeVisualHost } from "../ApidaeVisualHost";

type Variant =
  | "secondary100"
  | "grey"
  | "warning"
  | "primary100"
  | "primary10"
  | "green"
  | "darkgrey";

@customElement("apidae-detail-view-information-block")
export class InformationBlock extends ApidaeVisualHost {
  static styles: CSSResultGroup = unsafeCSS(informationBlockStyles);

  @property({ type: String })
  variant: Variant = "secondary100";

  @property({ type: Boolean })
  spacer: boolean = false;

  render() {
    return html`
      <div class="information-block information-block--${this.variant}">
        <div class="information-block-header">
          <slot name="header"></slot>
        </div>
        ${this.spacer ? html`<div class="information-block-spacer"></div>` : ""}
        <div class="information-block-content">
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
}
